import { useFormContext } from 'react-hook-form';

import type { PickTicketsItemCreateFormSchema } from './create-pick-tickets-item-modal/schema';

export function usePickTicketsItemFormContext() {
  const form = useFormContext<PickTicketsItemCreateFormSchema>();
  return form;
}
